var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: _vm.id } }, [
    _vm.isLoggedIn
      ? _c("div", { staticClass: "dropdown position-relative" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-menu small m-0 p-0 mw-100" }, [
            _c(
              "div",
              {
                staticClass: "list-group",
                attrs: { "aria-labelledby": "accountMenuList" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "list-group-item small text-dark d-xl-none d-md-none",
                    attrs: { href: _vm.$ceres.urls.myAccount },
                  },
                  [
                    _c("i", {
                      staticClass: "fa far fa-user mr-1 mr-xl-4",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "list-group-item small text-dark d-none d-md-inline-block order-3 order-xl-2",
                    attrs: { href: _vm.$ceres.urls.myAccount },
                  },
                  [
                    _c("i", {
                      staticClass: "fa far fa-bags-shopping mr-1 mr-xl-3",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$translate(
                            "modeherz::HeaderClient.myAccountOrders"
                          )
                        )
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "list-group-item small text-dark d-none d-md-inline-block order-2 order-xl-3",
                    attrs: { href: _vm.$ceres.urls.myAccount + "?myaCfg=1" },
                  },
                  [
                    _c("i", {
                      staticClass: "fa far fa-user mr-1 mr-xl-4",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [{ name: "logout", rawName: "v-logout" }],
                    staticClass:
                      "list-group-item small d-none d-xl-inline-block order-4",
                    attrs: { href: "#" },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-sign-out text-dark mr-3",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c("div", [
          _vm.showLogin
            ? _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: {
                    id: _vm.id + "-open-login-modal",
                    href: _vm.isLogin ? "javascript:void(0)" : "#login",
                    "data-toggle": _vm.isLogin ? false : "modal",
                    "aria-label": _vm.$translate(
                      "Ceres::Template.loginMyAccount"
                    ),
                  },
                  on: {
                    click: function ($event) {
                      _vm.createLoginModal()
                      _vm.createRegisterModal()
                      _vm.unmarkInputFields()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fal fa-user text-dark mr-2" }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "d-inline d-xl-none",
                      staticStyle: { "font-weight": "500" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "dropdown-toggle nav-link",
        attrs: {
          href: "#",
          id: "accountMenuList",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
          "data-boundary": "window",
        },
      },
      [_c("i", { staticClass: "fa fa fa-user text-dark mr-2" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }